export default __webpack_public_path__ + "static/media/NC_2043x115.414ec680.png";